import styled from 'styled-components'

export const FieldWrapper = styled.div`
  margin-bottom: 15px;
`

export const Label = styled.label`
  margin-bottom: 12px;
  display: block;
  color: ${({ theme }) => theme.colors.blueDark};
  line-height: 2.25;
`

export const StyledError = styled.div`
  color: ${({ theme }) => theme.colors.error};
  font-size: 14px;
  max-height: 0;
`

export const InputWrapper = styled.div`
  padding-bottom: 22px;
`
